<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="스킨 수정요청 내역"
    ></admin-filter>
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="modify" slot-scope="props">
        <button class="button" style="margin-right:8px"
                @click.stop.prevent="clickItem(props.item)">상세보기</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import AdminFilter from "../../../module/admin/AdminFilter";
  import ListMixin from "../../../../mixins/ListMixin";
  export default {
    name: "SkinInquiry",
    components: {AdminFilter},
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {}
    },
    methods: {
      init() {
        this.initializing('skin_inquiry', 'launchpack/v1/skin_inquiry');
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item) {
        this.routerPush(`/office/admin/launchpack/skin_inquiry/detail?id=${item.id}`);
      }
    }
  }
</script>

<style lang="stylus" scoped>

</style>
